// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa6ec51d","667":"942ed3a2"}[chunkId] + ".chunk.js";
};